import { render, staticRenderFns } from "./frame.vue?vue&type=template&id=0a89430f&scoped=true&"
import script from "./frame.vue?vue&type=script&lang=js&"
export * from "./frame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a89430f",
  null
  
)

export default component.exports